import { StepType } from 'enums';
import { StepCategoryConfig, StepsConfig } from 'pages/app-pages/chatbot-builder-page/nodes/config';

export function getCategoryColorByNodeType(nodeType: StepType): string {
  const stepConfig = StepsConfig[nodeType];
  const stepCategory = stepConfig.category;
  const categoryConfig = StepCategoryConfig[stepCategory];
  return categoryConfig.color;
}
